__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['banking-root'].baseUrl;
import { configureIguazuProcedures, configureIguazuResources } from './iguazu';
import configureProducts from './products';
import ModuleContainer from './components/BankingRoot';
configureIguazuProcedures();
configureIguazuResources();
configureProducts();
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.7.1',
      module: require('@americanexpress/one-experiments')
    },
    '@americanexpress/one-xp-client-sdk': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.35.2',
      module: require('@americanexpress/one-xp-client-sdk')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.1.4',
      module: require('@americanexpress/react-ddl')
    },
    '@emotion/core': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '10.3.1',
      module: require('@emotion/core')
    },
    '@americanexpress/reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.8',
      module: require('@americanexpress/reactlytics')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '6.8.9',
      module: require('react-intl')
    },
    'iguazu': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-rpc': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.1',
      module: require('iguazu-rpc')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'iguazu-holocron': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.8.2',
      module: require('iguazu-holocron')
    },
    'axp-product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.20',
      module: require('axp-product-ducks')
    },
    '@apollo/client': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.13.8',
      module: require('@apollo/client')
    },
    'graphql': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '15.10.1',
      module: require('graphql')
    },
    '@tanstack/react-query': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '4.36.1',
      module: require('@tanstack/react-query')
    },
    '@optimizely/react-sdk': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.4.0',
      module: require('@optimizely/react-sdk')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'banking-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'banking-root';
}